import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RegisterTypeModal from './register-type-modal';

import { toggleRegisterTypeModal } from '../actions/register-actions';

class RegisterType extends Component {
  componentDidMount = () => {
    const { toggleRegisterTypeModal } = this.props;

    toggleRegisterTypeModal(true);
  };

  render() {
    return (
      <div className="register-type">
        <RegisterTypeModal />
      </div>
    );
  }
}

RegisterType.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  toggleRegisterTypeModal: show => {
    dispatch(toggleRegisterTypeModal(show));
  },
});

RegisterType.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(RegisterType);



// WEBPACK FOOTER //
// ./src/app/main/register/components/register-type.js